
const MultiprofissionalStepForm =
[
    {
        key: 1,
        validateAllForms: false,
        mainStep: "GuideStep",
        steps: [
            { name: "GuideForm"},
        ]
    },
    {
        key: 2,
        validateAllForms: false,
        mainStep: "PersonalAddressDataStep",
        steps: [
            { name: "PersonalAddressDataForm"},
            { name: "PersonalDataForm" },
            { name: "AddressDataForm" }
        ]
    },
    {
        key: 3,
        validateAllForms: true,
        mainStep: "AcademicDegreeVocationalTraningStep",
        steps: [
            { name: "VocationalTraningForm" },
            { name: "AcademicDegreeForm" }
        ]
    },
    {
        key: 4,
        validateAllForms: false,
        mainStep: "BusinessAddressDataStep",
        steps: [
            { name: "BusinessDataForm" },
            { name: "BusinessAddressDataForm" }
        ]
    },
    {
        key: 5,
        validateAllForms: false,
        mainStep: "MultiprofissionalAttachmentDataStep",
        steps: [
            { name: "AttachmentForm" },
        ]
    },
    {
        key: 6,
        validateAllForms: false,
        mainStep: "TermsDeclarationsStep",
        steps: [
            { name: "TermsDeclarationsForm" },
            { name: "RefusalPresentVaccineForm" }
           
        ]
    }

];


export { MultiprofissionalStepForm };